import { type ElementDwellSpansCache, getElementDwellTimes } from './element-dwell-times';
import { type DwellSessionState, getDwellSessionId } from './session';

export interface DwellEmitPayload {
	sessionId: string;
	// ms-since-epoch timestamp of when the session opened.
	sessionStartedAt: number;
	// ms-since-epoch timestamp of when this interval boundary fired.
	intervalEndedAt: number;
	stepIndex: number;
	// Per-element dwell time in SECONDS, scoped to this interval.
	durations: Record<string, number>;
}

export type DwellEmitHandler = (payload: DwellEmitPayload) => void;

export function getEmitPayload(
	sessionState: DwellSessionState,
	spansCache: ElementDwellSpansCache,
	intervalEndedAt: number,
	stepIndex: number,
): DwellEmitPayload | null {
	const sessionId = getDwellSessionId(sessionState);
	if (sessionId === null || sessionState.startedAt === null) {
		return null;
	}

	const durationsMs = getElementDwellTimes(spansCache, intervalEndedAt);
	if (Object.keys(durationsMs).length === 0) {
		return null;
	}

	// Convert internal ms durations to seconds for the public payload.
	const durations: Record<string, number> = {};
	for (const key in durationsMs) {
		const ms = durationsMs[key];
		if (ms !== undefined) {
			durations[key] = ms / 1000;
		}
	}

	return {
		sessionId,
		sessionStartedAt: sessionState.startedAt,
		intervalEndedAt,
		stepIndex,
		durations,
	};
}
